export const Kalol = {
    title: "Kalol",
    title1: "(Industrial & Cultural City)",

    intro: "Kalol is a growing industrial town located in the Gandhinagar district of Gujarat. Known for its industrial importance, Kalol is home to several manufacturing units and industries, while also preserving a rich cultural heritage and vibrant community life.",

    attractions: [
        {
            name: "Kali Mata Temple",
            description: "The Kali Mata Temple is a significant religious site in Kalol, dedicated to the goddess Kali. It is known for its peaceful ambiance and attracts devotees seeking spiritual solace. The temple’s location on a hilltop offers a panoramic view of the surrounding area.",
            location: "Kalol, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Offer prayers and attend aarti",
                "Meditate in the temple's tranquil surroundings",
                "Enjoy the scenic view from the hilltop",
                "Participate in religious festivals",
                "Explore the temple's history and significance"
            ],
            mapLink: "https://maps.app.goo.gl/nvBeZcTtr57fM5sW8",
        },
        {
            name: "Kalol Lake",
            description: "Kalol Lake is a serene water body, providing a peaceful retreat for nature lovers. The lake is surrounded by lush greenery and serves as a great spot for relaxation, bird watching, and photography.",
            location: "Kalol, Gujarat",
            timings: "Open throughout the day",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Late Afternoon",
            activities: [
                "Relax by the lakeside",
                "Enjoy photography of the scenic landscape",
                "Birdwatching during the early hours",
                "Take a peaceful walk around the lake",
                "Enjoy a picnic with family or friends"
            ],
            mapLink: "https://maps.app.goo.gl/Qf7mFy27rLfYbsf98",
        },
        {
            name: "Brahmani Mata Temple",
            description: "Brahmani Mata Temple is another important spiritual site near Kalol. Dedicated to the goddess Brahmani, it attracts pilgrims and tourists alike for its spiritual significance and divine energy.",
            location: "Kalol, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend the daily prayers and aarti",
                "Meditate in the peaceful temple environment",
                "Explore the temple's beautiful architecture",
                "Participate in spiritual events",
                "Engage with the local community"
            ],
            mapLink: "https://maps.app.goo.gl/cWzvhtmUS7b1msk99",
        },
        {
            name: "Sardar Patel Park",
            description: "Sardar Patel Park is a family-friendly park located in the heart of Kalol. It is known for its lush greenery, walking tracks, and play areas. The park is ideal for morning walks, picnics, and outdoor activities.",
            location: "Kalol, Gujarat",
            timings: "6:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Enjoy a morning walk or jog",
                "Relax in the serene environment",
                "Take part in outdoor sports",
                "Have a picnic with friends and family",
                "Let kids enjoy the play area"
            ],
            mapLink: "https://maps.app.goo.gl/4FQb7EXk5PnBmn2y7",
        },
        {
            name: "Kalol Railway Station",
            description: "Kalol Railway Station, though primarily an industrial hub, has its own historical charm. It is one of the important railway stations in the region, connecting Kalol with major cities in Gujarat. The station is a gateway for travelers heading to the industrial areas and other nearby tourist spots.",
            location: "Kalol, Gujarat",
            timings: "24 Hours",
            ticket: "Train Fare",
            bestTimeToVisit: "Anytime (when traveling)",
            activities: [
                "Take a train ride to nearby cities",
                "Explore the area around the railway station",
                "Visit nearby shops and markets",
                "Admire the hustle and bustle of the station",
                "Experience local Gujarati snacks at the station vendors"
            ],
            mapLink: "https://maps.app.goo.gl/jM46D48Rvv7j2uQcA",
        },
        {
            name: "Kalol Industrial Area",
            description: "Kalol's industrial area is home to a wide range of factories and manufacturing units. The region contributes significantly to Gujarat's economy and industrial development. Visitors can explore the industrial units to get a glimpse of the area's industrial prowess.",
            location: "Kalol, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Restricted Access (industrial entry only with permission)",
            bestTimeToVisit: "Weekdays (for industrial tours)",
            activities: [
                "Learn about industrial processes and production",
                "Explore the various factories and plants",
                "Understand Gujarat's industrial growth",
                "Take guided tours to discover local industries",
                "Interact with workers and management"
            ],
            mapLink: "https://maps.app.goo.gl/c9SM4VQnHr5RvmPp8",
        },
    ]
};
